import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { TitreBudget } from '@components/titre-budget/models';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';
import { GenerateRangePipe } from '@shared/pipe';

@Component({
  selector: 'app-titre-budget',
  imports: [TitleComponent, GenerateRangePipe, SvgComponent, TranslatePipe],
  templateUrl: './titre-budget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitreBudgetComponent extends AbstractDynamicComponent<TitreBudget> {}
